export enum SiteSettingsApiEndpoints {
  PUT = '/sites/:siteId',
  POST_FREQ_CAPS = `/sites/:siteId/frequencycaps`,
  PUT_FREQ_CAPS = `/sites/:siteId/frequencycaps/:frequencyCapId`,
  DELETE_FREQ_CAPS = `/sites/:siteId/frequencycaps/:frequencyCapId`,
  GET_FREQ_CAPS = `/sites/:siteId/frequencycaps/:frequencyCapId`,
  GET_FREQ_CAPS_LIST = `/sites/:siteId/frequencycaps`,
  POST_BLOCK_ALLOW_LIST_ITEM = `/sites/:siteId/blocklist_allowlist_service/items`,
  GET_BLOCK_ALLOW_LIST = `/sites/:siteId/blocklist_allowlist_service/items?:queryString`,
  DELETE_BLOCK_ALLOW_LIST_ITEM = `/sites/:siteId/blocklist_allowlist_service/items/:item_key`,
}
